import * as React from "react";
import { gql, useMutation, useApolloClient } from "@apollo/client";
import { LogoutMutationMutation } from "../../schemaTypes";

const logoutMutation = gql`
  mutation LogoutMutation {
    logout
  }
`;

interface Props {
  children: (
    data: {
      logout: () => Promise<void>;
    }
  ) => React.ReactElement | null;
}

export const LogoutController: React.FC<Props> = ({ children }) => {
  const [_logoutMutation] = useMutation<LogoutMutationMutation>(logoutMutation);
  const client = useApolloClient();

  const logout = async () => {
    await _logoutMutation();
    await client.resetStore();
  };

  return children({ logout });
};